// Minimal HTML sanitizer to remove style/script tags and inline event handlers.
// Intent: allow simple inline markup from CMS while stripping unsafe/undesired parts.

export function sanitizeBasic(html: string | undefined | null): string {
  if (!html) return "";
  let output = html;
  // Remove <style>...</style>
  output = output.replace(/<style[\s\S]*?>[\s\S]*?<\/style>/gi, "");
  // Remove <script>...</script>
  output = output.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "");
  // Remove inline event handlers like onclick="..."
  output = output.replace(/\son[a-z]+\s*=\s*"[^"]*"/gi, "");
  output = output.replace(/\son[a-z]+\s*=\s*'[^']*'/gi, "");
  output = output.replace(/\son[a-z]+\s*=\s*[^\s>]+/gi, "");
  return output;
}

export default sanitizeBasic;


